import React from "react";

const Welcome: React.FC = () => {
  const currentDate = new Date();
  const hour = currentDate.getHours();

  // Determine greeting based on time
  const getGreeting = () => {
    if (hour < 12) return "Good Morning";
    if (hour < 17) return "Good Afternoon";
    return "Good Evening";
  };

  const greeting = getGreeting();

  const formattedDate = currentDate.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const formattedTime = currentDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const dayOfWeek = currentDate.toLocaleDateString("en-US", {
    weekday: "long",
  });

  return (
    <div className="relative flex flex-col md:flex-row justify-between gap-6 md:items-center mx-auto px-6 py-6 rounded-2xl shadow-md">
      <div className="text-black">
        <div className="font-['Outfit'] text-3xl md:text-4xl font-semibold leading-[40px] md:leading-[50px] tracking-normal text-amber-600">
          {greeting}
        </div>
        <div className="font-['Outfit'] text-[#555] text-base md:text-lg font-light leading-[24px] md:leading-[27px] tracking-[0.035rem]">
          Welcome to{" "}
          <span className="font-medium text-amber-500">Peakreach</span> admin
          dashboard
        </div>
      </div>
      <div className="text-base md:text-lg font-medium font-['Outfit'] leading-[24px] md:leading-[27px] tracking-tight md:absolute md:bottom-6 md:right-6 bg-white rounded-md px-3 py-1 shadow-sm text-amber-700">
        {`${formattedDate}, ${dayOfWeek} ${formattedTime}`}
      </div>
    </div>
  );
};

export default Welcome;
